//- Remunerations headers for employee details tab
export default [
    {
        text: 'Cuenta',
        value: 'acc_account_comment',
        sortable: false,
    },
    {
        text: 'Debe',
        value: 'debit_sum',
        format: 'currency',
        sortable: false,
    },
    {
        text: 'Haber',
        value: 'credit_sum',
        format: 'currency',
        sortable: false,
    },
    {
        text: 'Balance',
        value: 'balance_str',
        sortable: false,
    },
]
